import { color, isEscape, Text } from '@starrez/starryui9';
import React from 'react';
import styled from 'styled-components';
import { useViewPicker } from '../context/ViewPickerContext';
import { Item } from './ViewItem';
import { Caption } from './ViewItem.styles';

interface IViewItemWizardProps {
    divider?: boolean;
    title: string;
    onClick: () => void;
}

export const ViewItemWizard = ({ divider, title, onClick }: IViewItemWizardProps) => {
    const { closePicker } = useViewPicker();

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
        if (isEscape(e)) {
            e.stopPropagation();
            closePicker();
        }
    };

    return (
        <WizardItem role="option" divider={divider} onKeyDown={(e) => handleOnKeyDown(e)}>
            <Caption type="button" onClick={onClick} aria-haspopup="dialog">
                <Text color={color.Grey.G80} variant="normal.regular">
                    {title}
                </Text>
            </Caption>
        </WizardItem>
    );
};

interface IWizardItemProps {
    divider?: boolean;
}

const WizardItem = styled(Item)<IWizardItemProps>`
    ${({ divider }) =>
        divider &&
        `
        border-top: 1px solid ${color.Grey.G30};
    `}
`;
